import {
  extractPropertyId,
  getPdpUrlById,
  PROPERTY_CARD_FALLBACK_IMAGE_URL,
  PROPERTY_CARD_NO_PRICE_FIRST_TEXT,
  PROPERTY_CARD_NO_PRICE_SECOND_TEXT,
} from '@greystar/lib';
import { default as ResponsiveImage } from '../ResponsiveImage/ResponsiveImage';
import { PropertyCardProps } from './SearchList/SearchList';
import { BaseProductWithPriceOptions } from '../../component-props';

const formatAddress = (street?: string, city?: string, state?: string, zip?: string): string => {
  const parts = [street, city, state]
    .filter((part) => part && part.trim())
    .map((part) => part!.trim());
  let address = parts.join(', ');
  if (zip && zip.trim()) {
    address = address ? `${address} ${zip.trim()}` : zip.trim();
  }
  return address;
};

export const transformPropsIntoPropertyCards = (
  properties: BaseProductWithPriceOptions[],
  filterURL: string
): PropertyCardProps[] => {
  return properties.map((property, index) => ({
    id: extractPropertyId(property.clickUri) || index,
    name: property.ec_brand ?? '',
    address: formatAddress(
      property.additionalFields['address'] as string,
      property.additionalFields['city'] as string,
      property.additionalFields['state'] as string,
      property.additionalFields['postal_code'] as string
    ),
    cardUrl: getPdpUrlById(
      extractPropertyId(property.clickUri),
      property.ec_brand ?? '',
      property.additionalFields['city'] as string,
      property.additionalFields['state'] as string,
      filterURL
    ),
    tagName: (property.additionalFields['image_banner_text'] as string)?.trim(),
    isTag: !!(property.additionalFields['image_banner_text'] as string)?.trim(),
    tmlp: property.priceOptions.find((option) => option.type === 'tmlp')?.price,
    baseRent: property.priceOptions.find((option) => option.type === 'baseRent')?.price,
    propertyImage: property.ec_thumbnails[0] ? (
      <ResponsiveImage
        priority={index <= 6}
        loading={index <= 6 ? 'eager' : 'lazy'}
        image={`${property.ec_thumbnails[0]}`}
        fallbackImageSrc={PROPERTY_CARD_FALLBACK_IMAGE_URL}
        width={393}
        height={295}
        sizes="(max-width: 655px) 95vw, (max-width: 1270px) 50vw, (max-width: 1613px) 25vw, 20vw"
        alt={property.ec_brand ? `Property images of ${property.ec_brand}` : ''}
      />
    ) : (
      <img src={PROPERTY_CARD_FALLBACK_IMAGE_URL} alt="Property image" width={393} height={295} />
    ),
    withImageCarousel: false,
    bathrooms:
      typeof property.additionalFields['bathrooms'] === 'number'
        ? property.additionalFields['bathrooms']
        : undefined,
    bedrooms:
      typeof property.additionalFields['bedrooms'] === 'number'
        ? property.additionalFields['bedrooms']
        : undefined,
    noPriceFirstText: PROPERTY_CARD_NO_PRICE_FIRST_TEXT,
    noPriceSecondText: PROPERTY_CARD_NO_PRICE_SECOND_TEXT,
  }));
};
